import React, { memo, useEffect, useRef, useState } from 'react';
import { Dots } from '@yme/atoms/dots';
import { useWindowSize } from '@yme/hooks/index';
import { buildKey } from '@yme/utils/common';
import { DEFAULT_ITEM_CAROUSEL_CONFIG } from './config';
import { DEFAULT_GAP_BETWEEN_ITEMS } from './constants';
import { getSlides, getTransformLeft } from './helpers';
import { CarouselContentStyled, CarouselScrollableContentStyled, DotsWrapperStyled, ItemCarouselStyled, } from './styled';
import { useTouchBehaviors } from './useTouchBehaviors';
function CarouselComponent({ items, isRightToLeft, isDotsPanelVisible = false, getterSize = DEFAULT_GAP_BETWEEN_ITEMS, carouselConfig = DEFAULT_ITEM_CAROUSEL_CONFIG, ChildComponent, activeItem, onClickPrevItem, onClickNextItem, counts, setCounts, isDotsFixed, dataTestId = 'component', labels, daysToShowNew, isFromLabelShortForm, }) {
    const [transformLeftStep, setTransformLeftStep] = useState(0);
    const [transformLeftMax, setTransformLeftMax] = useState(0);
    const { width } = useWindowSize();
    const refCarousel = useRef(null);
    const refItemCarousel = useRef(null);
    useEffect(() => {
        const carouselWidth = Math.round(refCarousel.current?.getBoundingClientRect().width);
        const itemWidthWithGetter = Math.round(refItemCarousel.current?.getBoundingClientRect().width) + getterSize;
        const leftMax = items && itemWidthWithGetter * items.length - carouselWidth - getterSize;
        const slides = leftMax > 0 ? getSlides(itemWidthWithGetter, leftMax, getterSize) : 0;
        setTransformLeftStep(itemWidthWithGetter);
        setTransformLeftMax(leftMax);
        if (setCounts && slides) {
            setCounts(slides);
        }
    }, [getterSize, items, setCounts, width]);
    const { pointerDownHandler, pointerUpHandler, isDraggable, touchStartHandler, touchMoveHandler } = useTouchBehaviors({
        onClickPrevItem,
        onClickNextItem,
        isRightToLeft,
    });
    const isLastSlide = activeItem === counts - 1;
    const transformLeft = getTransformLeft({
        transformLeftStep,
        transformLeftMax,
        isLastSlide,
        activeItem,
        isRightToLeft,
    });
    return (React.createElement(React.Fragment, null,
        React.createElement(CarouselContentStyled, { "data-testid": buildKey(dataTestId, 'carousel') },
            React.createElement(CarouselScrollableContentStyled, { onTouchStart: touchStartHandler, onTouchMove: touchMoveHandler, onPointerDown: pointerDownHandler, onPointerUp: pointerUpHandler, ref: refCarousel, getterSize: getterSize, transformLeft: transformLeft }, items?.map((props, index) => {
                const cardProps = {
                    ...props,
                    daysToShowNew,
                    isFromLabelShortForm,
                };
                const itemCarouselProps = {
                    isRightToLeft,
                    labels,
                    cardProps,
                };
                return (React.createElement(ItemCarouselStyled, { ref: index === 0 ? refItemCarousel : null, key: buildKey(dataTestId, index), isActiveSlide: index === activeItem, isDraggable: isDraggable, "data-testid": buildKey(dataTestId, 'item-card'), 
                    // Main props for child component
                    carouselConfig: carouselConfig }, React.createElement(ChildComponent, itemCarouselProps)));
            }))),
        isDotsPanelVisible && (React.createElement(DotsWrapperStyled, null,
            React.createElement(Dots, { isDotsFixed: isDotsFixed, counts: counts, activeItem: activeItem, isRightToLeft: isRightToLeft })))));
}
export const Carousel = memo(CarouselComponent);
Carousel.displayName = 'Carousel_Atom';
